import './assets/styles2.css';const l = "_selectValue_lyzji_1", t = "_value_lyzji_21", e = "_singleValueLabel_lyzji_46", _ = "_tagGroup_lyzji_53", a = "_tagList_lyzji_57", o = "_multiValue_lyzji_63", u = "_placeholder_lyzji_71", c = "_multiTriggerButton_lyzji_79", i = "_clearButton_lyzji_94", n = "_chevron_lyzji_110", s = {
  selectValue: l,
  value: t,
  singleValueLabel: e,
  tagGroup: _,
  tagList: a,
  multiValue: o,
  placeholder: u,
  multiTriggerButton: c,
  clearButton: i,
  chevron: n
};
export {
  s as c
};
